var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"top":"","right":"","color":_vm.color,"timeout":_vm.timeout},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }